module.exports = __webpack_public_path__ + "static/media/tuyuren.bb6ef7d0.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/akopan/tuyuren.JPG
// module id = 34
// module chunks = 0